<template>
  <div class="accordion-item bg-transparent border-0">
    <div class="accordion-header" :id="'heading' + item.id">
      <button @click="showMore = !showMore" class="accordion-button flex-column collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + item.id" aria-expanded="true" :aria-controls="'collapse' + item.id">
        <div class="d-flex align-items-center gap-5 w-100 h-100">
          <div class="d-flex align-items-center gap-5">
            <div class="d-flex flex-column">
              <h5 class="fs-6 fw-bold d-flex align-items-center">
                {{ item.name }}
                <!-- On mobile only -->
                <a href="#" class="fs-6 fw-bold text-primary ms-2 d-lg-none d-block align-items-center text-decoration-none">
                  <div class="svg-icon me-2">
                    <svg id="ic-content-copy-48px" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 19 19">
                      <path id="Path_5" data-name="Path 5" d="M0,0H19V19H0Z" fill="none" />
                      <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M14.988,2H5.57A1.574,1.574,0,0,0,4,3.579v11.05H5.57V3.579h9.418Zm2.355,3.157H8.709a1.574,1.574,0,0,0-1.57,1.579v11.05a1.574,1.574,0,0,0,1.57,1.579h8.633a1.574,1.574,0,0,0,1.57-1.579V6.736A1.574,1.574,0,0,0,17.342,5.157Zm0,12.629H8.709V6.736h8.633Z"
                        transform="translate(-2.365 -1.182)"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </a>
              </h5>
              <span class="fs-14px text-secondary">{{ item.time }}</span>
            </div>
            <!-- Desktop only -->
            <div class="d-lg-flex d-none flex-column">
              <h5 class="fs-14px text-secondary">المنصة</h5>
              <img src="@/assets/images/2560px-Google_Meet_text_logo_(2020).svg_2x.png" width="110" alt="" />
            </div>
            <div class="d-lg-flex d-none flex-column">
              <h5 class="fs-14px text-secondary">المدة</h5>
              <span class="fs-14px">{{ item.duration }}</span>
            </div>
            <!-- End desktop only -->
          </div>
          <div v-if="showMore" class="text-secondary fs-6 ms-auto d-flex align-items-center gap-3">
            إظهار أقل
            <img src="@/assets/images/chevron-backward-aaccordion.svg" alt="" />
          </div>
          <div v-else class="text-secondary fs-6 ms-auto d-flex align-items-center gap-3">
            التفاصيل
            <img src="@/assets/images/chevron-right.svg" alt="" />
          </div>
        </div>
        <!-- Only on mobile -->
        <div class="d-lg-none w-100">
          <div class="border-top border-2 my-3"></div>
          <div class="d-flex">
            <div class="d-flex flex-column accordion-details-list gap-2">
              <span class="fs-12px text-secondary">المنصة</span>
              <img src="@/assets/images/zm-02_2x.png" width="50" alt="" />
            </div>
            <div class="d-flex flex-column accordion-details-list section-seperator ps-3 gap-2">
              <span class="fs-12px text-secondary">المدة</span>
              <span class="fs-12px">30 د</span>
            </div>
          </div>
        </div>
      </button>
    </div>
    <div :id="'collapse' + item.id" class="accordion-collapse collapse" :aria-labelledby="'heading' + item.id" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <!-- Desktop only -->
        <div class="d-lg-flex d-none align-items-center gap-5">
          <div class="d-flex flex-column">
            <h5 class="fs-14px text-secondary">البريد</h5>
            <span class="fs-14px">{{ item.email }}</span>
          </div>
          <div class="d-flex flex-column">
            <h5 class="fs-14px text-secondary">رابط اللقاء</h5>
            <a href="#" class="fs-6 fw-bold text-primary d-flex align-items-center text-decoration-none">
              <div class="svg-icon me-2">
                <svg id="ic-content-copy-48px" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 19 19">
                  <path id="Path_5" data-name="Path 5" d="M0,0H19V19H0Z" fill="none" />
                  <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M14.988,2H5.57A1.574,1.574,0,0,0,4,3.579v11.05H5.57V3.579h9.418Zm2.355,3.157H8.709a1.574,1.574,0,0,0-1.57,1.579v11.05a1.574,1.574,0,0,0,1.57,1.579h8.633a1.574,1.574,0,0,0,1.57-1.579V6.736A1.574,1.574,0,0,0,17.342,5.157Zm0,12.629H8.709V6.736h8.633Z"
                    transform="translate(-2.365 -1.182)"
                    fill="currentColor"
                  />
                </svg>
              </div>
              نسخ الرابط
            </a>
          </div>
          <div class="d-flex flex-column">
            <h5 class="fs-14px text-secondary">نوع الموعد</h5>
            <span class="fs-14px">{{ item.type }}</span>
          </div>
        </div>
        <!-- Mobile only -->
        <div class="d-lg-none w-100">
          <div class="d-flex">
            <div class="d-flex flex-column accordion-details-list gap-2">
              <span class="fs-12px text-secondary">البريد</span>
              <span class="fs-14px">{{ item.email }}</span>
            </div>
            <div class="d-flex flex-column accordion-details-list section-seperator ps-3 gap-2">
              <span class="fs-12px text-secondary">نوع الموعد</span>
              <span class="fs-14px">{{ item.type }}</span>
            </div>
          </div>
        </div>

        <hr />
        <h5 class="fs-6 fw-bold">الاسألة</h5>
        <div class="mb-3" v-for="q in item.questions" :key="q.id">
          <label for="" class="text-secondary fs-14px mb-1">{{ q.title }}</label>
          <textarea readonly class="form-control" v-model="q.answare"></textarea>
        </div>
        <hr />
        <div class="d-flex align-items-center gap-4">
          <button class="btn btn-outline-primary rounded-pill btn-lg d-flex align-items-center fs-6" data-bs-toggle="modal" data-bs-target="#reMeetModal" type="button">
            <div class="svg-icon me-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.01" height="17.446" viewBox="0 0 17.01 17.446">
                <path
                  id="reload.1"
                  d="M3.745,10.723a6.978,6.978,0,0,1,6.978-6.978,6.844,6.844,0,0,1,5.393,2.611l-1.465,0A.872.872,0,1,0,14.646,8.1l3,.009a.869.869,0,0,0,.1,0h.385a.872.872,0,0,0,.875-.872V3.745a.872.872,0,0,0-1.745,0V5.009A8.575,8.575,0,0,0,10.723,2a8.723,8.723,0,1,0,7.759,12.6.872.872,0,1,0-1.562-.776,6.894,6.894,0,0,1-6.2,3.877A6.978,6.978,0,0,1,3.745,10.723Z"
                  transform="translate(-2 -2)"
                  fill="currentColor"
                />
              </svg>
            </div>
            إعادة جدولة اللقاء
          </button>
          <div class="dropdown">
            <button class="btn dropdown-toggle p-0" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <img src="@/assets/images/dots.svg" width="25" alt="" />
            </button>
            <ul class="dropdown-menu rounded-3 border-0 shadow-sm dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
              <li>
                <button class="dropdown-item border-bottom" @click="successToast()" type="button">تعيين كإفتراضي</button>
              </li>
              <li>
                <button data-bs-toggle="modal" data-bs-target="#addteamModal" class="dropdown-item" type="button">حذف الكارد</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from '@vue/reactivity'
export default {
  props: ['item'],
  setup() {
    const showMore = ref(false)

    return {showMore}
  },
}
</script>

<style>
</style>